export default {
   /* 
    Essa é uma regra genérica que verirfica se 0 v-model está com algum 
    valor se estiver vazio ela irá pintar de vermelho e imprimir a mensagem.
    É possivel implementar mais de uma regra por variável, mas lembre-se, ao
    colocar mais de uma regra o campo terá que passar em todas, caso contrário 
    ele será invalidado.  
    exemplos de regras:
    v => (v && v.length <= 10) || 'Name must be less than 10 characters',
    v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    */
   ruleToCheckIfEmailIsValid:         value => /.+@.+\..+/.test(v)   || 'Utilize um email válido!',
   ruleToCheckIfTheValuesInTheFields: value => !!value               || 'Campo obrigatório!',
   ruleToCheckTheLengthOfString:      value => (v && v.length <= 10) || 'Name must be less than 10 characters',
}



// WEBPACK FOOTER //
// ./src/utils/RulesToForms.js